<template>
    <DCard
        padding
    >
        <Form
            :original-brand="originalBrand"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/OriginalBrands/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    originalBrand: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function submitData (form) {
    form.patch(route('settings.original-brands.update', { originalBrand: props.originalBrand.id }))
}
</script>
